// src/pages/Settings/index.jsx
import React from 'react';
import ThemeToggle from 'components/ThemeToggle';
import { useTheme } from 'context/ThemeContext';
import SectionCard from 'components/SectionCard';
import Subsection from 'components/Subsection';
import Page from 'components/Page';
import MfaEnroll from 'components/MfaEnroll';

export default function Settings() {
  const { theme, setTheme } = useTheme();

  return (
    <Page title="Settings">
      <div className="max-w-3xl space-y-6">
        {/* Two-Factor Authentication */}
        <SectionCard title="Two-Factor Authentication">
          <p className="text-sm text-muted mb-4">
            Protect your account by requiring a second factor when signing in.
            Uses your preferred mobile Authenticator app (Microsoft, Google, Authy...)
          </p>

          {/* Match Appearance → Theme styling */}
          <Subsection>
            <MfaEnroll />
          </Subsection>
        </SectionCard>

        {/* Appearance */}
        <SectionCard title="Appearance">
          <p className="text-sm text-muted mb-4">
            Choose your display theme. “System” follows your device theme.
          </p>

          <Subsection title="Theme">
            <div className="flex items-center gap-3">
              <ThemeToggle />
              {theme !== 'system' ? (
                <button
                  type="button"
                  onClick={() => setTheme('system')}
                  className="btn btn-primary"
                >
                  Reset to System
                </button>
              ) : null}
            </div>
          </Subsection>
        </SectionCard>
      </div>
    </Page>
  );
}
